"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { CartIcon } from "@/components/shop/CartIcon";
export default function MobileStickyBar() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="mobilestickybar" data-nav="light" aria-label="Barra de compra rápida" className="fixed bottom-0 inset-x-0 z-50 flex sm:hidden pb-[env(safe-area-inset-bottom,0px)]">
      <motion.div initial={shouldReduceMotion ? {
      opacity: 1,
      y: 0
    } : {
      y: "100%",
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      duration: 0.32,
      ease: [0.16, 1, 0.3, 1]
    }} className="w-full bg-card/95 backdrop-blur-md border-t border-border shadow-lg px-4 py-3">
        <div className="flex items-center gap-3 max-w-md mx-auto">
          <div className="flex-1">
            <motion.div whileTap={shouldReduceMotion ? undefined : {
            scale: 0.98
          }} className="w-full">
              <Button asChild className="w-full h-12 rounded-full bg-primary text-primary-foreground hover:bg-primary/90 font-medium text-base shadow-sm">
                <Link to="#full-kit-destacado" aria-label="Comprar kit de hongos funcionales">
                  Comprar kit
                </Link>
              </Button>
            </motion.div>
          </div>

          <div className="shrink-0 flex items-center justify-center">
            <div className="rounded-full bg-secondary/80 p-1 border border-border/60">
              <CartIcon iconType="bag" openDrawerOnAdd={true} variant="ghost" size="icon" iconSize="size-5" className="size-10 rounded-full text-foreground hover:bg-accent/40" />
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}